export default {
  balance: [],
  bankAccounts: [],
  bankAccount: {},
  banksList: [],
  transactions: [],
  withdraws: [],
  pagination: {}
};
